/** OfferingsCatalogRoute — skin-aware switcher for /offerings. */
import { useUISkin } from "@/data/UISkinContext";
import OfferingsCatalog from "./OfferingsCatalog";
import OfferingsCatalogCockpit from "./OfferingsCatalogCockpit";

export default function OfferingsCatalogRoute() {
  const { skin } = useUISkin();
  if (skin === "cockpit") return <OfferingsCatalogCockpit />;
  return <OfferingsCatalog />;
}
